import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  type: "text/css",
  href: "./assets/css/styles_kfplc_1.css"
}, null, -1)
const _hoisted_3 = { class: "app__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_header = _resolveComponent("v-header")!
  const _component_v_navbar = _resolveComponent("v-navbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.legalteamview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.showHeaderFooter)
            ? (_openBlock(), _createBlock(_component_v_header, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.showHeaderFooter)
              ? (_openBlock(), _createBlock(_component_v_navbar, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath
    }))
  ]))
}